import { OutboundLink } from "react-ga";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = theme => ({
  button: {
    borderRadius: "3px",
    marginTop: "1rem",
    marginLeft: "0.5rem",
    marginRight: "0.5rem",
    minWidth: "48px",
    width: "auto",
    padding: "1rem",
    color: theme.colours.palette.white,
    fontWeight: 400,
    textDecoration: "none",
    textAlign: "center",
    boxShadow: "2px 2px 5px #888888",
    "&:hover": {
      transform: "translate(2px, 2px)",
      webkitTransform: "translate(2px, 2px)",
      mozTransform: "translate(2px, 2px)",
      oTransform: "translate(2px, 2px)",
      msTransform: "translate(2px, 2px)",
      boxShadow: "0 0 0"
    },
    "@media (max-width: 1024px)": {
      padding: "0.5rem",
      minWidth: "24px",
      marginLeft: "0.25rem",
      marginRight: "0.25rem",
      fontSize: "1rem"
    }
  }
});

const Button = ({ classes, label, linkUrl, className = "" }) => (
  <OutboundLink
    className={`${classes.button} ${className}`}
    to={linkUrl}
    eventLabel={`${label} " button"`}
  >
    {label}
  </OutboundLink>
);

Button.propTypes = {
  classes: PropTypes.object,
  label: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired
};

export default injectSheet(styles)(Button);



// WEBPACK FOOTER //
// ./src/components/ButtonRow/Button.jsx